import React from 'react';
import { toast } from 'react-toastify';

// Custom Toast Component with Icon
const ToastContent = ({ icon, message, title }) => (
  <div className="toast-content-wrapper">
    <div className="toast-icon">{icon}</div>
    <div className="toast-content">
      {title && <div className="toast-title">{title}</div>}
      <div className="toast-message">{message}</div>
    </div>
  </div>
);

// Success Icon
const SuccessIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </svg>
);

// Error Icon
const ErrorIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
  </svg>
);

// Warning Icon
const WarningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
  </svg>
);

// Info Icon
const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
  </svg>
);

// Loading Icon
const LoadingIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z">
      <animateTransform 
        attributeName="transform" 
        type="rotate" 
        from="0 12 12" 
        to="360 12 12" 
        dur="1s" 
        repeatCount="indefinite"/>
    </path>
  </svg>
);

// Default toast options
const defaultOptions = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Custom toast utilities
export const toastUtils = {
  // Success toast
  success: (message, title, options = {}) => {
    toast.success(
      React.createElement(ToastContent, {
        icon: React.createElement(SuccessIcon),
        title: title,
        message: message
      }),
      { ...defaultOptions, ...options }
    );
  },

  // Error toast
  error: (message, title, options = {}) => {
    toast.error(
      React.createElement(ToastContent, {
        icon: React.createElement(ErrorIcon),
        title: title,
        message: message
      }),
      { ...defaultOptions, ...options }
    );
  },

  // Warning toast
  warning: (message, title, options = {}) => {
    toast.warning(
      React.createElement(ToastContent, {
        icon: React.createElement(WarningIcon),
        title: title,
        message: message
      }),
      { ...defaultOptions, ...options }
    );
  },

  // Info toast
  info: (message, title, options = {}) => {
    toast.info(
      React.createElement(ToastContent, {
        icon: React.createElement(InfoIcon),
        title: title,
        message: message
      }),
      { ...defaultOptions, ...options }
    );
  },

  // Loading toast
  loading: (message, title, options = {}) => {
    return toast.info(
      React.createElement(ToastContent, {
        icon: React.createElement(LoadingIcon),
        title: title,
        message: message
      }),
      { 
        ...defaultOptions, 
        autoClose: false, 
        closeOnClick: false,
        className: 'toast-loading',
        ...options 
      }
    );
  },

  // Dismiss specific toast
  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },

  // Dismiss all toasts
  dismissAll: () => {
    toast.dismiss();
  }
};

export default toastUtils;